export default {
  computed: {
    schemaSekolah2023() {
      const bulan = this.$getDeepObj(this.info, 'bulan') || '';

      return {
        dasar: {
          title: 'Gambaran Umum Kegiatan',
          laporan: [
            {
              type: 'textView',
              label: 'Bulan Pelaksanaan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: bulan || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VRadio',
              name: 'is_terlaksana',
              label: 'Apakah fasilitator ini memiliki sekolah dampingan Sekolah Penggerak Angkatan 3',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              hideDetails: +this.form.is_terlaksana === 1,
              items: [
                { text: 'Ya', value: 1 },
                { text: 'Tidak', value: 0 },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              exist: { status: +this.form.is_terlaksana === 1 },
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Tanggal Pelaksanaan',
              labelColor: 'indigo',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              required: true,
              outlined: true,
              singleLine: true,
              hideDetails: false,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              exist: { status: +this.form.is_terlaksana === 1 },
              type: 'textView',
              label: 'Moda yang diterapkan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: 'Daring',
              grid: { cols: 12, md: 6 },
            },
          ],
        },
        peserta: {
          hidden: +this.form.is_terlaksana !== 1,
          title: 'Jumlah peserta yang hadir',
          laporan: [
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_kasek',
              label: 'Jumlah Kepala Sekolah',
              labelColor: 'indigo',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_pengawas',
              label: 'Jumlah Pengawas',
              labelColor: 'indigo',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_guru',
              label: 'Jumlah Guru',
              labelColor: 'indigo',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
          ],
        },
        kegiatan: {
          hidden: +this.form.is_terlaksana !== 1,
          title: 'Pelaksanaan Kegiatan',
          laporan: this.listInstrumen['sekolah'],
        },
      };
    },
  },
};
